import { FC } from 'react';
import { Divider, Form, Table, Typography } from 'antd';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { OfficeObservationPaymentSystem } from '@/libs/fleet-api/services/types';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';

type OfficeObservationPaymentSystemData =
	OfficeObservationPaymentSystem<'payload'> &
		Pick<OfficeObservationPaymentSystem, 'paymentSystem'>;

type VisitReportPaymentSystemForm = {
	lists: OfficeObservationPaymentSystemData[];
};

const FBDHVisitReportPaymentSystem: FC = () => {
	const { officeObservation } = useFBDHVisitReportApprovalPage();
	const { marketingAspect } = officeObservation ?? {};
	const { form, fieldName } = useForm<VisitReportPaymentSystemForm>();

	return (
		<Form.Provider>
			<Typography.Title level={3}>Sistem Pembayaran</Typography.Title>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				initialValues={
					{
						lists:
							marketingAspect?.paymentSystem.map((record) => {
								return {
									paymentSystem: record.paymentSystem,
									paymentSystemId: record.paymentSystem.id,
									portionPercentage: record.portionPercentage,
									surveyId: record.surveyId,
									id: record.id,
								};
							}) ?? [],
					} as VisitReportPaymentSystemForm
				}
				style={{ marginBottom: 30 }}
			>
				<Form.Item
					name={fieldName(['lists'])}
					noStyle
				/>
				<Form.Item shouldUpdate>
					{({ getFieldsValue }) => {
						const values = getFieldsValue() as VisitReportPaymentSystemForm;
						const dataSource =
							values?.lists?.map((list, key?) => {
								return { ...list, key };
							}) ?? [];

						return (
							<Table
								bordered
								pagination={false}
								dataSource={dataSource}
								columns={[
									{
										title: 'No',
										render: (_, __, index) => index + 1,
										width: 1,
									},
									{
										title: 'Sistem Pembayaran',
										render: (_, record) => record.paymentSystem.value ?? '-',
									},
									{
										title: 'Porsi',
										render: (_, record) => record.portionPercentage ?? '-',
									},
								]}
							/>
						);
					}}
				</Form.Item>
			</Form>
			<Divider />
		</Form.Provider>
	);
};

export default FBDHVisitReportPaymentSystem;
